// extracted by mini-css-extract-plugin
module.exports = {"host":"DayOfWeekPicker_host__4H1iv","label":"DayOfWeekPicker_label__2UKN_"};